// SCSS
import "@/assets/scss/styles.scss";
import Paging from "@/component/paging/Paging.vue";
import Tooltip from "@/component/ui/Tooltip.vue";
import dayjs from "dayjs";
import filesaver from "file-saver";
import lodash from "lodash";
import { buildVueDompurifyHTMLDirective } from "vue-dompurify-html";
import axios from "./axios";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

const app = createApp(App);

window.addEventListener("beforeunload", () => {
    sessionStorage.setItem("wasReload", "true");
});

const domPurifyConfig = {
    default: {
        ADD_ATTR: ["target"],
    },
    hooks: {
        uponSanitizeElement: (node) => {
            if (node.tagName !== "A") {
                return;
            }
            const href = node.getAttribute("href") || "";

            if (!href.startsWith("http")) {
                return;
            }

            // target 속성이 없으면 '_blank'를 자동으로 추가
            if (!node.getAttribute("target")) {
                node.setAttribute("target", "_blank");
            }

            // 보안을 위해 rel="noopener noreferrer"도 함께 추가하는 것이 권장됩니다.
            if (!node.getAttribute("rel")) {
                node.setAttribute("rel", "noopener noreferrer");
            }
        },
    },
};

// 전역 에러 핸들러
app.config.errorHandler = (err, instance, info) => {
    console.error("Vue 전역 에러 발생:", err, info);
    axios.setErrorSession(500);
};

app.use(store)
    .use(router)
    .provide("axios", axios)
    .provide("dayjs", dayjs)
    .provide("lodash", lodash)
    .provide("filesaver", filesaver)
    .component("tooltip", Tooltip)
    .directive("dompurify-html", buildVueDompurifyHTMLDirective(domPurifyConfig))
    .component("Paging", Paging)
    .mount("#app");
